



import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
 apiKey: "AIzaSyAZniRuUaSe_6240mCF3ELCpXr2yfD1NtE",
  authDomain: "astha-digitalservices.firebaseapp.com",
  projectId: "astha-digitalservices",
  storageBucket: "astha-digitalservices.firebasestorage.app",
  messagingSenderId: "279312809050",
  appId: "1:279312809050:web:66743e3814fe16758d6c63",
  measurementId: "G-GC7DHJLZ7D"
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;



